
<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

    <!-- 1. Billing Logic -->
    <app-diagnostic-test-card
        title="Billing Logic"
        scenario="Overage & Credit"
        icon="fa-solid fa-file-invoice-dollar"
        theme="blue"
        [steps]="['Injects 1000 THB credit.', 'Forces plan limits to trigger overage.', 'Verifies deduction happens on approval.']"
        [isRunning]="isRunningLogicTest()"
        [result]="billingTestResult()"
        (runTest)="runBillingTest()">
    </app-diagnostic-test-card>

    <!-- 2. Payment Health -->
    <app-diagnostic-test-card
        title="Payment Health"
        scenario="Webhook & Consistency"
        icon="fa-solid fa-shield-heart"
        theme="pink"
        [steps]="['Scan for plan/sub mismatches.', 'Check for logic traps in wallets.', 'Audit stuck subscriptions.']"
        [isRunning]="isRunningPaymentTest()"
        [result]="paymentTestResult()"
        (runTest)="runPaymentTest()">
    </app-diagnostic-test-card>

    <!-- 3. Clearing & Gov (Auditor) -->
    <app-diagnostic-test-card
        title="Auditor Access"
        scenario="Read-Only Security"
        icon="fa-solid fa-user-secret"
        theme="lime"
        [steps]="['Verify Auditor READ Access.', 'Verify Auditor WRITE Block (Security).', 'Ensure no modification allowed.']"
        [isRunning]="isRunningAuditorTest()"
        [result]="auditorTestResult()"
        (runTest)="runAuditorTest()">
    </app-diagnostic-test-card>

    <!-- 4. Clearing & Gov (Ledger) -->
    <app-diagnostic-test-card
        title="Clearing Ledger"
        scenario="Payout Generation"
        icon="fa-solid fa-money-bill-transfer"
        theme="lime"
        [steps]="['Simulate Approval.', 'Check Ledger Entry Creation.', 'Verify Status = PENDING.']"
        [isRunning]="isRunningClearingTest()"
        [result]="clearingLedgerResult()"
        (runTest)="runClearingTest()">
    </app-diagnostic-test-card>

    <!-- 5. Patient Data -->
    <app-diagnostic-test-card
        title="Patient Data"
        scenario="Security & HN"
        icon="fa-solid fa-id-card-clip"
        theme="cyan"
        [steps]="['Same ID in same Store = Upsert (Safe).', 'Same ID in Diff Store = Insert (OK).', 'Verify HN sequence per store.']"
        [isRunning]="isRunningCustomerTest()"
        [result]="customerTestResult()"
        (runTest)="runCustomerTest()">
    </app-diagnostic-test-card>

    <!-- 6. Partner Network -->
    <app-diagnostic-test-card
        title="Partner Network"
        scenario="Connection Logic"
        icon="fa-solid fa-handshake"
        theme="indigo"
        [steps]="['Attempts self-connection (Should Fail).', 'Connects Store A to Store B (Should Pass).', 'Attempts reverse connection (Should Fail).']"
        [isRunning]="isRunningPartnerTest()"
        [result]="partnerTestResult()"
        (runTest)="runPartnerTest()">
    </app-diagnostic-test-card>

    <!-- 7. Inventory Logic -->
    <app-diagnostic-test-card
        title="Inventory Logic"
        scenario="Stock Adjustment"
        icon="fa-solid fa-boxes-stacked"
        theme="amber"
        [steps]="['Deduct stock via Sale (-10).', 'Add stock via Restock (+20).', 'Verify Pht.27/28 compliance logic.']"
        [isRunning]="isRunningInventoryTest()"
        [result]="inventoryTestResult()"
        (runTest)="runInventoryTest()">
    </app-diagnostic-test-card>

    <!-- 8. Medical Flow -->
    <app-diagnostic-test-card
        title="Medical Flow"
        scenario="Referral & Approval"
        icon="fa-solid fa-notes-medical"
        theme="pink"
        [steps]="['Store A sends Referral to Store B.', 'Security check: Store C cannot view it.', 'Doctor B engages and approves case.']"
        [isRunning]="isRunningMedicalTest()"
        [result]="medicalTestResult()"
        (runTest)="runMedicalTest()">
    </app-diagnostic-test-card>

    <!-- 9. Dispensing Logic -->
    <app-diagnostic-test-card
        title="Dispensing Logic"
        scenario="Used & Deduct"
        icon="fa-solid fa-prescription-bottle-medical"
        theme="teal"
        [steps]="['Setup: Product (100) & Approved RX.', 'Action: Dispense 10 units.', 'Verify: RX status = USED, Stock = 90.']"
        [isRunning]="isRunningDispensingTest()"
        [result]="dispensingTestResult()"
        (runTest)="runDispensingTest()">
    </app-diagnostic-test-card>

    <!-- 10. Financial Safety -->
    <app-diagnostic-test-card
        title="Financial Safety"
        scenario="Overage Blocking"
        icon="fa-solid fa-ban"
        theme="red"
        [steps]="['Setup: Store with full quota & 0 wallet.', 'Attempt Approval: MUST FAIL.', 'Top up wallet, Retry: MUST PASS.']"
        [isRunning]="isRunningFinancialSafetyTest()"
        [result]="financialSafetyResult()"
        (runTest)="runFinancialSafetyTest()">
    </app-diagnostic-test-card>

    <!-- 11. Referral Billing -->
    <app-diagnostic-test-card
        title="Referral Billing"
        scenario="Double Lock"
        icon="fa-solid fa-building-lock"
        theme="purple"
        [steps]="['Setup: Disp. (Empty Wallet) -> Clinic (Rich).', 'Attempt Approval: MUST FAIL (Sender cannot pay).', 'Top up Dispensary, Retry: MUST PASS.']"
        [isRunning]="isRunningReferralBillingTest()"
        [result]="referralBillingResult()"
        (runTest)="runReferralBillingTest()">
    </app-diagnostic-test-card>

    <!-- 12. Registration Logic -->
    <app-diagnostic-test-card
        title="Registration Logic"
        scenario="Plan Assignment"
        icon="fa-solid fa-user-plus"
        theme="emerald"
        [steps]="['Simulates \'DISPENSARY\' signup -> \'Tier D\'.', 'Simulates \'CLINIC\' signup -> \'Tier S\'.', 'Verifies Trial Duration & Expiry Logic.']"
        [isRunning]="isRunningRegistrationTest()"
        [result]="registrationTestResult()"
        (runTest)="runRegistrationTest()">
    </app-diagnostic-test-card>

    <!-- 13. Queue Logic (New) -->
    <app-diagnostic-test-card
        title="Queue System"
        scenario="FIFO & Race Condition"
        icon="fa-solid fa-users-line"
        theme="blue"
        [steps]="['Mock 3 stores sending cases.', 'Simulate race conditions.', 'Verify FIFO ordering in Clinic.']"
        [isRunning]="isRunningQueueTest()"
        [result]="queueTestResult()"
        (runTest)="runQueueTest()">
    </app-diagnostic-test-card>

    <!-- 14. Socket Load (New) -->
    <app-diagnostic-test-card
        title="Socket Load"
        scenario="50 Simultaneous Inserts"
        icon="fa-solid fa-server"
        theme="red"
        [steps]="['Simulate 50 rapid insertions.', 'Verify data integrity.', 'Measure total processing latency.']"
        [isRunning]="isRunningQueueLoad()"
        [result]="queueLoadResult()"
        (runTest)="runQueueLoadTest()">
    </app-diagnostic-test-card>

</div>
